
import React from "react";
import "./Invoice.css";

const Invoice = () => {
  return (
    <div className="card">
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-custom table-bordered">
              <tr>
                <td className="" colSpan="12">
                  <span className="h4">QUOTATIONS</span>
                  <p className="h6 mb-0">
                    INFISUITE SERVICES INDIA PRIVATE LIMITED
                    LEVEL NOS 812, Block 5, MH2 BUILDING, HYD, 500009
                  </p>
                </td>
              </tr>
              <tr>
                <td width="20%" className="" style={{ verticalAlign: "top" }}>
                  <img src="./logo.png" alt="Logo" style={{ width: "200px", padding: "0" }} />
                </td>
                <td width="25%" align="center" className="" style={{ verticalAlign: "top", paddingRight: "40px" }}>
                  {/* <span>THANK YOU FOR YOUR ORDER. THIS DOCUMENT IS A RECEIPT OF YOUR PURCHASE.</span> */}
                </td>
                <td width="55%" colSpan="4" className="">
                  <div className="table-responsive" style={{ background: "transparent" }}>
                    <table className="table">
                      <tbody>
                        <tr>
                          <td style={{ background: "transparent" }} className=""><p className="mb-0">To</p></td>
                          <td style={{ background: "transparent" }} className="" align="right"><p className="mb-0">NovaWorks Group</p></td>
                        </tr>
                        <tr>
                          <td style={{ background: "transparent" }} className=""><p className="mb-0">PARTY ID</p></td>
                          <td style={{ background: "transparent" }} className="" align="right"><p className="mb-0">56</p></td>
                        </tr>
                        <tr>
                          <td style={{ background: "transparent" }} className=""><p className="mb-0">Date</p></td>
                          <td style={{ background: "transparent" }} className="" align="right"><p className="mb-0">25 Jul 2024</p></td>
                        </tr>
                        <tr>
                          <td style={{ background: "transparent" }} className=""><p className="mb-0">QUOTATIONS NO</p></td>
                          <td style={{ background: "transparent" }} className="" align="right"><p className="mb-0">QT0055</p></td>
                        </tr>
                        <tr>
                          <td style={{ background: "transparent" }} className=""><p className="mb-0">NUMBER OF ITEMS</p></td>
                          <td style={{ background: "transparent" }} className="" align="right"><p className="mb-0">1</p></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="" style={{ verticalAlign: "bottom" }}>
                  <img src="./logo.png" alt="Logo" style={{ width: "200px", padding: "0" }} />
                </td>
                <td align="center" className="pt-5" style={{ verticalAlign: "bottom", paddingRight: "40px" }}>
                  <p className="f-14 h6">NovaWorks Group, 63/3 Sashtri nagar, near ramamand bus stop, Jalgaon, Maharashtra 425001</p>
                </td>
                <td colSpan="4" className="" style={{ verticalAlign: "bottom" }}>
                  <p className="h6">PRODUCT PURCHASED</p>
                </td>
              </tr>
              <tr>
                <td colSpan="6">&nbsp;</td>
              </tr>
              <tr>
                <th className="">ITEM</th>
                <th className=""></th>
                <th className="" width="20%">PRODUCTION DESCRIPTION</th>
                <th className="text-end" width="">QTY</th>
                <th className="text-end" width="">UNIT PRICE (INR)</th>
                <th className="text-end" width="">AMOUNT (INR)</th>
              </tr>
              <tr>
                <td className="" style={{ verticalAlign: "top" }}>
                  <img src="./logo.png" alt="item" style={{ width: "100px", padding: "0" }} className="img-fluid" onError={(e) => e.target.src = './logo.png'} />
                </td>
                <td className="" style={{ verticalAlign: "top" }}></td>
                <td className="" style={{ verticalAlign: "top" }}>
                  <span className="d-block h6 mb-0 f-13">Laptop Computer</span>
                  <span className="d-block h6 mb-0 f-13">Laptop Computer</span>
                </td>
                <td className="" align="right" style={{ verticalAlign: "top" }}>1.00</td>
                <td className="" align="right" style={{ verticalAlign: "top" }}>15,500.00/-</td>
                <td align="right" style={{ verticalAlign: "top" }}>15,500.00/-</td>
              </tr>
              <tr>
                <td colspan="2"></td>
                <th colspan="2">Total</th>
                <th colspan="2" className="text-end">INR 15,500.00/-</th>
              </tr>
              <tr>
                <td colspan="2"></td>
                <th colspan="2">Discount</th>
                <th colspan="2" className="text-end">0.00</th>
              </tr>
              <tr>
                <td colspan="2"></td>
                <th colspan="2">Shipping Charges</th>
                <th colspan="2" className="text-end">0.00</th>
              </tr>
              <tr>
                <td colspan="2"></td>
                <th colspan="2">CGST 9% on 15,500.00</th>
                <th colspan="2" className="text-end">INR 1,395.00/-</th>
              </tr>
              <tr>
                <td colspan="2"></td>
                <th colspan="2">SGST 9% on 15,500.00</th>
                <th colspan="2" className="text-end">INR 1,395.00/-</th>
              </tr>
              <tr>
                <td colspan="2"></td>
                <th colspan="2">Grand Total</th>
                <th colspan="2" className="text-end">INR 18,290.00/-</th>
              </tr>
              <tr>
                <td colspan="2"></td>
                <th colspan="4">Eighteen Thousands Two Hundred And Ninety Rupees Only</th>
              </tr>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Invoice;
